// TODO: remove with https://github.com/combinaut/sparkle/issues/31634 once the page builder is rewritten.

/** Returns the first attribute's messages from a Rails JSON error response as one sentence, e.g. "name is too short and has already been taken". */
export function sharedComponentErrorMessage(errors) {
  const [attribute, messages] = Object.entries(errors)[0];
  const last = messages.at(-1);
  const sentence = messages.length > 1 ? `${messages.slice(0, -1).join(", ")} and ${last}` : last;

  return `${attribute} ${sentence}`;
}
